import React, { useState } from 'react'
import styled from '@emotion/styled'
import { breakpoints } from '../../utils/styles'

const Tabs = props => {
  const { children } = props
  const [activeTab, setActiveTab] = useState(children[0].props.label)

  const onClickTabItem = tab => {
    setActiveTab(tab)
  }

  return (
    <div className="tabs" {...props}>
      <div className="tab-list">
        {children.map(child => {
          if (!child) return null
          const { label } = child.props

          return (
            <Tab
              activeTab={activeTab}
              key={label}
              label={label}
              onClick={onClickTabItem}
            />
          )
        })}
      </div>
      <div className="tab-content">
        {children.map(child => {
          if (!child) return null
          if (child.props.label !== activeTab) return undefined
          return child.props.children
        })}
      </div>
    </div>
  )
}

export default Tabs

const Tab = ({ activeTab, label, onClick }) => {
  return (
    <Toggle
      onClick={e => {
        e.preventDefault()
        onClick(label)
      }}
      style={{
        borderBottom: activeTab === label ? '3px solid #215041' : 'none',
      }}
    >
      {label}
    </Toggle>
  )
}

const Toggle = styled.button`
  cursor: pointer;
  margin-right: 20px;
  background: none;
  appearance: none;
  padding: 0;
  padding-bottom: 5px;
  outline: none;
  border-left: none;
  border-right: none;
  color: #215041;
  font-family: 'SohneBreit';
  border-top: none;
  letter-spacing: 1px;
  font-size: 16px;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }
`

export const Box = styled.button`
  width: 100%;
  background: #215041;
  color: white;
  border: none;
  text-align: center;
  font-size: 16px;
  max-width: 280;
  cursor: pointer;
  line-height: 30px;
`
